export const educationData = [
  {
    id: 1,
    institution: "Amrita school of engineering",
    course: "Bachelor Degree",
    startYear: "2017",
    endYear: "2021",
  },
  {
    id: 2,
    institution: "FIITJEE",
    course: "Intermediate",
    startYear: "2014",
    endYear: "2016",
  },
];
